// src/pages/AuthCallback.tsx
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { fetchAuthSession, getCurrentUser } from 'aws-amplify/auth';
import { useDispatch } from 'react-redux';
import { setUser } from '../store/slices/authSlice';

const AuthCallback = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  useEffect(() => {
    const handleCallback = async () => {
      try {
        const { tokens } = await fetchAuthSession();
        const user = await getCurrentUser();
        
        if (tokens && tokens.accessToken) {
          dispatch(setUser({
            email: user.username,
            sub: user.userId,
            accessToken: tokens.accessToken.toString()
          }));
          
          navigate('/dashboard');
        } else {
          throw new Error('No access token available');
        }
      } catch (error) {
        console.error('Authentication error:', error);
        navigate('/login');
      }
    };

    handleCallback();
  }, [navigate, dispatch]);

  return null;
};

export default AuthCallback;